import { call, put, takeLatest } from 'redux-saga/effects'
import * as ApiRouter from 'constants/apiRouting'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import {
  FETCH_FILTERS,
  FETCH_TABLE_DATA,
  SET_TABLE_DATA,
  LOAD_TABLE_DATA,
  CLEAR_TABLE_DATA,
  EXPORT_TO_CSV,
} from './action'
import { SHOW_NOTICE } from '../notice'

function* fetchFilters({ payload: { query }, promise: { resolve, reject } }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.MY_JOBS_DATA_VIEWER_FILTERS,
        query,
      ),
    })

    const isError = response.hasOwnProperty('error')

    if (isError && reject) {
      return yield call(reject, response)
    }

    if (!isError && resolve) {
      return yield call(resolve, response)
    }
  } catch (error) {
    console.log('FETCH_FILTERS ERROR', error)
  }
}

function* fetchTableData({ payload }) {
  try {
    yield put({ type: LOAD_TABLE_DATA, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        `${ApiRouter.MY_JOBS_DATA_VIEWER_TABLE}${UrlHelper.getPsfsQuery(
          payload,
        )}`,
        payload.params,
      ),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SET_TABLE_DATA, payload: response })
    } else {
      yield put({ type: CLEAR_TABLE_DATA })
    }

    yield put({ type: LOAD_TABLE_DATA, payload: false })
  } catch (error) {
    console.log('FETCH_TABLE_DATA ERROR', error)
  }
}

function* exportToCsv({ payload, promise }) {
  try {
    const { data, headers } = yield call(
      fetchFromAPI,
      {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.createQuery(
          `${ApiRouter.DATA_VIEWER_EXPORT_CSV}${UrlHelper.getPsfsQuery(
            payload,
            { paginationParamsEnabled: false },
          )}`,
          payload.params,
        ),
      },
      ['data', 'headers'],
    )

    if (data.hasOwnProperty('error')) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(data.message),
      })

      return yield call(promise.resolve)
    }

    if (
      !headers.hasOwnProperty('content-type') ||
      !headers.hasOwnProperty('content-disposition')
    ) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('File cannot be downloaded'),
      })

      return yield call(promise.resolve)
    }

    const type = headers['content-type'].toLowerCase().replace(' ', '')
    const [, filename] =
      headers['content-disposition'].match(/filename="([^"]+)/i) || []

    if (!type || !filename) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('File cannot be downloaded'),
      })

      return yield call(promise.resolve)
    }

    const csvContent = new Blob([data], { type })
    const link = document.createElement('a')
    link.download = filename
    link.href = URL.createObjectURL(csvContent)
    link.click()
    URL.revokeObjectURL(link.href)

    yield call(promise.resolve)
  } catch (error) {
    console.log('EXPORT DATA FAILED ', error)

    return promise.resolve()
  }
}

function* myJobsDataViewerSaga() {
  yield takeLatest(FETCH_FILTERS, fetchFilters)
  yield takeLatest(FETCH_TABLE_DATA, fetchTableData)
  yield takeLatest(EXPORT_TO_CSV, exportToCsv)
}

export default myJobsDataViewerSaga
